import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  ButtonSearch,
  SPACING,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SearchArea = (props: SearchAreaProps) => {
  const { currentBreakpoint } = useBreakpointHelpers();
  const { t } = useLocalizationContext();
  const wrapperStyle = [
    styles.wrapper,
    !currentBreakpoint.isMobile && styles.wrapperTabletUp,
  ];

  return (
    <View style={wrapperStyle} pointerEvents="box-none">
      <ButtonSearch
        accessibilityLabel={t('location.map-search-area')}
        accessibilityHint={t('location.map-search-area-a11y-hint')}
        isLoading={props.isLoading}
        disabled={props.disabled}
        onPress={props.onPress}
      >
        {t('location.map-search-area')}
      </ButtonSearch>
    </View>
  );
};

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type SearchAreaProps = Pick<
  React.ComponentProps<typeof ButtonSearch>,
  'onPress' | 'isLoading' | 'disabled'
>;

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    flexDirection: 'row',
    paddingTop: SPACING.medium,
    paddingHorizontal: SPACING.medium,
  },
  wrapperTabletUp: {
    justifyContent: 'center',
    paddingTop: SPACING.large,
  },
});
